import React from "react";
import Viewer from "../components/Viewer";
import { Technicians } from "../graphql/querys/technicians";
import { DELETE_TECHNICIAN, EDIT_TECHNICIAN_PASSWORD } from "../graphql/mutation/technician";


export default function TechniciansScreen() {
	return (
		<Viewer
			viewerInfo="technicians"
			viewerQueryAll={Technicians}
			deleteTechnicianMutation={DELETE_TECHNICIAN} // Pass the delete mutation
			editTechnicianPasswordMutation={EDIT_TECHNICIAN_PASSWORD} // Pass the edit password mutation
		/>
	);
}
